import { IReadingsStore } from './types';

const initStore: IReadingsStore = {
  items: [],
};

export default initStore;
